import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2878464499/src/signage-website/components/case-studies/CaseStudiesIndex.client.tsx");
